module.exports = __webpack_public_path__ + "static/media/tuandui.453a8971.png";